import { useUser } from '@/constants/UserContext';

export type EffectiveOrg = {
  /** True when the viewer is an org account, or a volunteer acting as an org admin. */
  isOrgView: boolean;
  /** True only for an actual organization account. */
  isOrganization: boolean;
  /** The org being acted for, or null in the plain volunteer view. */
  effectiveOrgId: string | null;
};

/**
 * "Am I acting as an organization right now, and which one?"
 *
 * VolunteersPage, EventPreviewModal and OrganizationsPage each hand-roll this same
 * derivation; new code should use this instead.
 */
export function useEffectiveOrgId(): EffectiveOrg {
  const { user, activeAdminOrgId } = useUser();
  const isOrganization = user?.role === 'organization';
  const effectiveOrgId = isOrganization ? (user?.id ?? null) : activeAdminOrgId;
  return {
    isOrgView: isOrganization || Boolean(activeAdminOrgId),
    isOrganization,
    effectiveOrgId,
  };
}
